import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SearchProvider } from './context/SearchContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import AboutUs from './components/AboutUs/AboutUs';
import Home from './components/Home';
import ListingConfirm from './components/ListingConfirm/ListingConfirm';
import ListingDetail from './components/ListingDetail/ListingDetail';
import ListingsGrid from './components/ListingsGrid/ListingsGrid';
import ListingReserved from './components/ListingReserved/ListingReserved';
import Login from './components/login/Login';
import Rent from './components/Rent/Rent';
import Register from './components/register/Register';
import ResetPassword from './components/resetPassword/ResetPassword';
import SendResetPassword from './components/sendResetPassword/SendResetPassword';
import ContactForm from './components/ContactForm/ContactForm';
import FacebookPixelListener from "./hooks/useFacebookPixel";

const App = () => {
  return (
    <AuthProvider>
      <SearchProvider>
          <Router>
            <FacebookPixelListener />
            <Routes>
              <Route path="*" element={<Navigate to="/home" />} />
              <Route path="/aboutUs" element={<AboutUs />} />
              <Route path="/confirm/:listingId" element={<ListingConfirm />} />
              <Route path="/home" element={<Home />} />
              <Route path="/contact" element={<ContactForm />} />
              <Route path="/listings/" element={<ListingsGrid />} />
              <Route path="/listings/:listingId" element={<ListingDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/rent" element={<Rent />} />
              <Route path="/reserved" element={<ListingReserved />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/send-reset-password" element={<SendResetPassword />} />
              <Route path="/user-register" element={<Register />} />
            </Routes>
          </Router>
      </SearchProvider>
    </AuthProvider>
  );
};

export default App;
